<template>
  <div>
    <div class="upcomingBkarea">
      <template v-if="tournID != 'por'">
        <Upcoming :Year="tm_params.tm_params.season_code" :config="config" :DEFIMAGESAMS3="DEFIMAGESAMS3" :tournID="tournID" :code="tm_params.code"/>
      </template>
      <template v-else>
        <Upcoming :Year="id" :config="config" :DEFIMAGESAMS3="DEFIMAGESAMS3" :tournID="tournID" :code="tm_params.code"/>
      </template>
    </div>
    <b-card title="Card Title" no-body class="card-remove-border">
      <b-container>
        <b-row class="TitleArea PadTop">
            <b-col sm="12" lg="12">
              <h1 class="heading extraPad">
                Clutch Tour  
                <template v-if="tournID == 'cpt'">Tier 1</template>
                <template v-else-if="tournID == 'cp2'">Tier 2</template>
                <template v-else-if="tournID == 'cp3'">Amateur</template>
                <template v-else-if="tournID == 'pam'">Pro-Ams</template>
                <template v-else-if="tournID == 'por'">Portugal Series</template>
                <template v-else-if="tournID == 'qsc'">Q-School</template>
                
                Schedule {{id}}</h1>
            </b-col>
            <!-- <b-col sm="12" lg="4">
            </b-col> -->
            <!-- <b-col sm="12" lg="4" class="Searchbox">
              <span class="FilterYear">
                <div class="outerInput">
                  <input onfocus="this.placeholder = ''" onblur="this.placeholder = 'Find Tournament'" class="form-control Findatourn" type="text" v-model="search" placeholder=" Find Tournament" />
                  <div>
                    <img class="searchMag" src="https://assets.asiantour.com/asian-tour/2023/12/Icon_feather-search.png">
                  </div>
                </div>
              </span>
            </b-col> -->
        </b-row>
        <ScheduleTable
          :fields="fields"
          :id="id"
          :data="data"
          :code="tm_paramsCodetwo"
          :search="search"
          :months="months"
          :tournDates="tournNewDates"
          :newReports="newReports"
          :config="config"
        />
      </b-container>
    </b-card>
    <div class="scheduleNews" v-if="showPost == true">
      <b-container>
        <Post :tournID="tournID"/>
      </b-container>
    </div>
    <Download :config="config" />
  </div>
</template>

<script>
import ScheduleTable from "@/components/scheduleTable.vue";
import Post from "@/components/posts.vue";
import Download from "@/components/download.vue";
import Upcoming from "@/components/slider.vue";
import apiCall from "@/services/api.js";
import axios from 'axios';
export default {
  name: "schedule",
  props: ["config"],
  components: {
    ScheduleTable,
    Upcoming,
    Download,
    Post
  },
  data() {
    return {
      id: [],
      seasonCode: '',
      tm_params: [],
      tm_paramsCodetwo: '',
      data: [],
      fields: [
        { key: "dates", label: "Dates" },
        { key: "full_name", label: "Tournament" },
        { key: "course", label: "course", class:'noCourse' },
        { key: "total_prize_fund", label: "Prize Fund" , class: 'fundClass'},
        { key: "reports", label: "Reports", class: 'ReportClass' },
      ],
      search: '',
      months: [
        {
          value: 'Jan',
          full_name: 'January'
        },
        {
          value: 'Feb',
          full_name: 'February'
        },
        {
          value: 'Mar',
          full_name: 'March'
        },
        {
          value: 'Apr',
          full_name: 'April'
        },
        {
          value: 'May',
          full_name: 'May'
        },
        {
          value: 'Jun',
          full_name: 'June'
        },
        {
          value: 'Jul',
          full_name: 'July'
        },
        {
          value: 'Aug',
          full_name: 'August'
        },
        {
          value: 'Sep',
          full_name: 'September'
        },
        {
          value: 'Oct',
          full_name: 'October'
        },
        {
          value: 'Nov',
          full_name: 'November'
        },
        {
          value: 'Dec',
          full_name: 'December'
        },
      ],
      tournNewDates: [],
      arr: [],
      newReports: [],
      showPost: false
    };
  },
  methods: {
    gettournPosts: function() {
    var json = ''
    if (this.tournID == 'cpt') {
      json = "4"; 
    } else if (this.tournID == 'cp2') {
      json = "5";
    } else if (this.tournID == 'cp3') {
      json = "6";
    } else if (this.tournID == 'pam') {
      json = "7";
    } else if (this.tournID == 'qsc') {
      json = "8";
    } else if (this.tournID == 'por') {
      json = "40";
    } else {
      json = "";
    }
      console.log("InPost")
      return axios.get(
        'https://wp-cpt.ocs-software.com/wp-json/wp/v2/posts?categories=' + json +
         "&randomaddPost=" + new Date().getTime()
        )
      .then(response => {
        this.postData = response.data;
        if (this.postData.length > 0) {
          this.showPost = true
        } else {
          this.showPost = false
        }
      });
    },
    changeYear: function(event) {
      var id = event.target.getAttribute("title");
      return (
        (this.id = id),
        this.callTwo(id)
      );
    },
    filterDates: function() {
        let arr = [];
        this.tournDates = arr;
        this.data.forEach((value) => {
            arr.push(value.dic_dates.slice(0,3));
        });

        let uniqueArray = [];
        let arrayWithDuplicates = this.tournDates;
        this.tournNewDates = uniqueArray;
        arrayWithDuplicates.forEach((value) => {
            if (!uniqueArray.includes(value)) {
                uniqueArray.push(value);
            }
        });
        console.log("tournNewDates");
        console.log(this.tournNewDates);
    },
    callOne() {
      apiCall
        .tmParamsBase()
        .then(({ data }) => {
          this.tm_params = data;
          this.id = data.tm_params.season_code;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
      return console.log("one");
    },
    callTwo() {
      apiCall
        .tmParamsYear(this.id)
        .then(({ data }) => {
          // this.data = data.tournaments.tournaments_entry;
          if (Array.isArray(data.tournaments.tournaments_entry)) {
            this.data = data.tournaments.tournaments_entry;
          } else {
            this.data = [data.tournaments.tournaments_entry]
          }

          // looping through tournaments to get reports arrays
          let arr = [];
          this.arr = arr;
          this.data.forEach((value) => {
              arr.push(value.reports.reports_entry);
              console.log("value");
              console.log(value.reports.reports_entry);
          });
          
          // looping through reports to filter out stats ect
          const oldReports = this.arr[0];
          const newReports = [];
          this.newReports = newReports;

          for (let i = 0; i < oldReports.length; i++) {
            if (oldReports[i].report_title !== "Statistics Tables" && oldReports[i].report_title !== "Statistics" && oldReports[i].report_title !== "Scoring Statistics" && oldReports[i].report_title !== "Course Statistics") {
              newReports.push(oldReports[i]);
            }
          }
          console.log("New Reports: " + newReports);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
      return console.log("two");
    },
  },
  async mounted() {
    // this.callTwo()
    try {
      // First call, await for call to return
      let first_call = await apiCall.tmParamsBase();
      console.log("first_call")
      console.log(first_call)
      this.tm_params = first_call.data;
      this.tm_paramsCode = first_call.data.code;
      this.tournID = this.$route.query.tour;
      console.log("this.tm_paramsCode")
      console.log(this.tm_paramsCode)
      if (this.tournID === 'por') {
        // this.id = Number(first_call.data.tm_params.season_code);
        this.id = Number('2027');
        console.log("this.ids:", this.id);
      } else {
        this.id = first_call.data.tm_params.season_code;
        console.log("this.id:", this.id);
      }
      // this.tournID = this.$route.query.tour;
      // // this.tournID = 'mena';
      // console.log("this.tournID")
      // console.log(this.tournID)
      this.filterDates();
      this.gettournPosts();
      this.loading = false;
      // Second call, await for call to return
      let second_call = await apiCall.tmParamsYear(this.id, this.tournID);
      this.tm_paramsCodetwo = second_call.data.code;
      this.seasonCode = second_call.data.tm_params.season_code;
      console.log("this.tm_paramsCodetwo")
      console.log(this.tm_paramsCodetwo)
      if (Array.isArray(second_call.data.tournaments.tournaments_entry)) {
        this.data = second_call.data.tournaments.tournaments_entry;
      } else {
        this.data = [second_call.data.tournaments.tournaments_entry]
      }
      this.filterDates();
      this.loading = false;
    } catch (error) {
      console.log("error in await calls");
      console.log(error);
      throw error;
    }
  }
};
</script>

<style scoped>
.scheduleNews {
  background-color: #F2F2F2;
  padding: 5%;
}
::v-deep .card {
  padding-bottom: 100px;
}
::v-deep td.fundClass {
  text-align: right;
}
::v-deep span.prizeText {
  display: block;
  text-align: right;
  font-size: 18px;
}
::v-deep th.fundClass > div {
  position: relative;
  /* left: -100px; */
}
::v-deep th.ReportClass > div {
  position: relative;
  /* left: -50px; */
}
::v-deep td.fundClass > span {
  position: relative;
  left: -50px;
  font-weight: bold;
  text-align: right;
  top: 3px;
}
::v-deep td.ReportClass > ul > a > .reportBTN {
  position: relative;
  left: -45px;
}
::v-deep .Searchbox.col {
  padding-top: 11px;
}
img.searchMag {
  position: absolute;
  right: 40px;
  top: 30px;
}
::v-deep .form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  text-align: left;
  float: right;
  /* width: 244px; */
  height: 52px;
  background: transparent;
  color: #8b8a8a;
  font-weight: 500;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
    margin-top: 10px;
}
::v-deep .dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #081C3F !important;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.row.TitleArea.PadTop {
  padding-top: 40px;
}
h1.heading.extraPad {
  /* padding: 20px; */
}
.heading{
  /* font-weight: 600; */
  font-size: 36px;
  color: #081C3F;
  position: relative;
  /* top: 25px; */
  top: 5px;
  margin-bottom: 50px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
::v-deep a.allNewsLink.router-link-exact-active.router-link-active {
  display: none;
}
.upcomingBkarea {
  background-color: #F8F8F8;
  padding: 45px;
  padding-right: 0;
  padding-left: 0;
}
.card-remove-border {
  border: none;
}
nav.card-header.dropdown-seasons {
  padding-left: 30px;
  background: none;
  border: none;
  border-top: 0px;
  float: right;
}
/* ::v-deep button {
  font-size: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
  background-color: #081C3F;
  color: #ffffff;
  border-radius: 0px;
  border: 0px;
  height: 30px;
  width: 100%;
  text-align: left;
  float: right;
  width: 244px;
  height: 50px;
  background: transparent;
  color: #8b8a8a;
  font-weight: 500;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
} */
::v-deep button::before{
  padding-left: 10px;
}
::v-deep button::after {
  float: right;
  margin-top: 8px;
}
.dropdown {
  /* width: 25%; */
}
::v-deep button:hover {
  color: #081C3F!important;
  background-color: #bde9d8;
}
::v-deep tr:nth-child(even) {
  background-color: #ffff;
}
@media only screen and (max-width: 1200px) { 
  ::v-deep .fundClass {
    display: none;
  }
}
@media only screen and (max-width: 990px) {
  ::v-deep .card {
    padding-bottom: 25px;
  }
  .scheduleNews {
    background-color: #F2F2F2;
    padding-top: 5%!important;
    padding: 0%;
  }
  ::v-deep .dropdown {
    width: 100%!important;
  }
  nav.card-header.dropdown-seasons {
    padding-left: 10px;
    background: none;
    border: none;
    border-top: 0px;
    float: none;
    margin-top: 30px;
  }
  img.searchMag {
    position: absolute;
    right: 40px;
    top: 30px;
  }
}
@media only screen and (max-width: 425px) {
  .dropdown {
    width: 40%;
  }
}
.tourLink > a {
    font-weight: 500;
    padding: 0.5rem 0;
    color: #000000 !important;
    font-size: 16px;
}
</style>
